import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { DataService } from '../data.service';

/** Read/update dbo.mp_widget_company_config via mfg-api (theme, predictedPricing, splitPendingApprovalMultiPart, keepPartFilesLocal, etc.). */
@Injectable()
export class CompanyWidgetConfigService {
  constructor(private _dataService: DataService) {}

  getConfig(companyId: number): Observable<{ config: Record<string, any> }> {
    const url = `CompanyWidgetConfig/Get?companyId=${companyId}`;
    return this._dataService.getAll(url, '');
  }

  /** Body must be the full merged config object (same as config_json). */
  saveConfig(companyId: number, config: Record<string, any>): Observable<any> {
    const url = `CompanyWidgetConfig/Save?companyId=${companyId}`;
    return this._dataService.UpdateWithoutId(url, config);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/company-widget-config/company-widget-config.service.ts